import { Theme } from '@emotion/react';

export const getBorderColor =
  (focused?: boolean, error?: boolean, warning?: boolean, disabled?: boolean) => (theme: Theme) => {
    if (error) {
      return theme.error35;
    } else if (focused) {
      return theme.black;
    } else if (warning) {
      return theme.darkOrange;
    } else if (disabled) {
      return theme.superlightGrey;
    }

    return theme.neutral85;
  };

export const getLabelColor =
  (error?: boolean, warning?: boolean, disabled?: boolean) => (theme: Theme) => {
    if (error) {
      return theme.error35;
    } else if (warning) {
      return theme.darkOrange;
    } else if (disabled) {
      return theme.grey; // TODO: WCAG - matter to change
    }

    return theme.neutral35;
  };
